import { productLabel } from '@/lib/licenses'

/** «CLOUD_BASE×1, CLOUD_USER×3» or «SERVER×1, TERMINAL×2», as the overview sends what is in force. */
export function holdingLabels(holdings: string | null | undefined): string[] {
  if (!holdings) return []
  return holdings.split(',').map((part) => part.trim()).filter(Boolean).map((part) => {
    const [code = '', count] = part.split('×')
    const quantity = Number(count ?? 1)
    if (code === 'SERVER') return 'Servidor'
    if (code === 'TERMINAL') return `Terminales: ${quantity}`
    const name = productLabel(code, code)
    return quantity > 1 ? `${quantity} × ${name}` : name
  })
}

/** How a licence state reads as a chip: green in force, teal waiting on someone, red lapsed or refused. */
export function stateTone(state: string): 'active' | 'attention' | 'lapsed' | undefined {
  if (state === 'ACTIVE' || state === 'VALIDATED') return 'active'
  if (state === 'PENDING' || state === 'EXPIRING') return 'attention'
  if (state === 'EXPIRED' || state === 'REJECTED') return 'lapsed'
  return undefined
}

/** Pesos as typed («3,890.00», «$3890») to cents; null when empty, NaN when it is not an amount. */
export function pesosToCents(value: string): number | null {
  const text = value.trim().replace(/[$,\s]/g, '')
  if (!text) return null
  const amount = Number(text)
  return Number.isFinite(amount) && amount >= 0 ? Math.round(amount * 100) : Number.NaN
}
